export enum DocumentType {
  OrderConfirmation = 'order-confirmation',
  CreditNote = 'credit-note',
  DeliveryNote = 'delivery-note',
  Invoice = 'invoice',
}
